import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";

const useStateGetter = () => {
  var isloading = useSelector((state: any) => state.isloading);
  var showmodal = useSelector((state: any) => state.showmodal);
  var showWizard = useSelector((state: any) => state.showWizard);
  var authuser = useSelector((state: any) => state.authuser);
  var verifyemail = useSelector((state: any) => state.verifyemail);
  var SidebarRenderView = useSelector((state: any) => state.SidebarRenderView);
  var SelectedOrg = useSelector((state: any) => state.SelectedOrg);
   const modalOBJ = useSelector((state:any)=>state.modalOBJ)
   const setSelecteduser=useSelector((state:any)=>state.setSelecteduser)
   const config = useSelector((state:any)=>state.config)
   const breadcrumbsTitle = useSelector((state:any)=>state.breadcrumbsTitle)
   const selectedDept = useSelector((state:any)=>state.selectedDept)
   const Allmodules = useSelector((state:any)=>state.Allmodules)
   const selectedEmployee = useSelector((state:any)=>state.selectedEmployee)
  const ismobile = useMediaQuery({ query: "(max-width: 1224px)" });
  const [isTabletOrMobile, setisTabletOrMobile] = useState(ismobile);


  useEffect(() => {
    setisTabletOrMobile(ismobile);
  }, [ismobile]);

  return {setSelecteduser, selectedEmployee,selectedDept,breadcrumbsTitle, SidebarRenderView, isloading,Allmodules,SelectedOrg, showWizard,config,authuser, verifyemail,showmodal,isTabletOrMobile ,modalOBJ};
};

export { useStateGetter };
